import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initializeDemoData } from "./data/demoData";
import { verifyStorageIntegrity } from "./api/config";
import "./index.css";

// Inicializar datos de demo
initializeDemoData();

// Verificar integridad de datos después de inicializar
// Solo en desarrollo para no saturar la consola en producción
if (process.env.NODE_ENV === "development") {
  setTimeout(() => {
    const integrity = verifyStorageIntegrity();
    if (!integrity.valid || integrity.errors.length > 0) {
      console.error("⚠️ Problemas de integridad detectados:", integrity.errors);
    }
    if (integrity.warnings.length > 0) {
      console.warn("⚠️ Advertencias de integridad:", integrity.warnings);
    }
    if (integrity.valid && integrity.warnings.length === 0) {
      console.log("✓ Integridad de datos verificada correctamente", integrity.stats);
    }
  }, 500);
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

